export default "__VITE_ASSET__xmAdBEmS__"